import { IconType } from "react-icons";

type BadgeProps = {
  label: string;
  classes: string;
  icon?: IconType;
};

export const Badge: React.FC<BadgeProps> = ({ label, classes, icon: Icon }) => (
  <span
    className={`inline-flex items-center
        px-3 py-1 text-md font-medium ${classes}`}
  >
    {Icon ? <Icon className="w-4 h-4 mr-2" /> : null}
    {label}
  </span>
);
